import 'jquery-validation/dist/jquery.validate';

// Version 4.0.3 of Select2 contains an error so it's not loaded through bower
// See: https://github.com/select2/select2/pull/4356
// Imported version contains the fix
import 'select2/dist/js/select2.full';

export default function() {

    $('.js-select2').each(function() {
        const context = this;

        let options = {
            'language': {
                "noResults": () => {
                    return $(this).attr('data-i18n-noResults') || 'Geen resultaten gevonden';
                },
                'searching': () => {
                    return $(this).attr('data-i18n-searching') || 'Zoeken...';
                }
            },
            width: 'resolve'
        };

        if ($(this).hasClass('js-select2-marker')) {
            options.ajax = {
                url: $(this).attr('data-url'),
                dataType: 'json',
                delay: 250,
                cache: false,
                data: function(params) {
                    return {
                        searchTerm: params.term,
                        activeMembersOnly: $(this).attr('data-rule-required')
                    };
                },
                processResults: function (data) {
                    if (data.Error) {
                        return {
                            results: [{
                                error: data.Error
                            }]
                        }
                    } else {
                        return {
                            results: $.map(data, function(obj) {
                                return {
                                    id: obj.Id || ($(this).attr('data-rule-required') ? null : '|' + obj.FullName),
                                    text: obj.FullName,
                                    photoUrl: obj.PhotoUrl || $(context).attr('data-defaultPhotoUrl'),
                                    city: obj.City || '',
                                    error: obj.Error
                                };
                            })
                        };
                    }
                },
                error: function(response) {
                    // console.log(response);
                }
            };

            options.placeholder = {
                id: -1,
                text: $(this).attr('data-i18n-placeholder')
            },
            options.escapeMarkup =  function (markup) {
                return markup;
            }
            options.templateResult = function(marker) {
                if (marker.loading) {
                    return marker.text;
                }

                if (marker.error) {
                    return marker.error;
                }

                const markup = '<div class="c-marker">'+
                    '<div class="c-marker__headshot c-headshot"><img src="'+marker.photoUrl+'" /></div>' +
                    '<div class="c-marker__text">' +
                        '<div class="c-marker__title">'+marker.text+'</div>' +
                        '<div class="c-marker__subtitle">'+marker.city+'</div>' +
                    '</div>' +
                '</div>';

                return markup;
            }
        }

        $(this).select2(options);
    });

    // Validation rules for the authorization forms
    $('.js-auth-form').validate({
        errorClass: '-error',
        errorContainer: ".js-errorLabelContainer",
        errorLabelContainer: ".js-errorLabelContainer",
        errorPlacement: function(error, element) {
            $(element).closest('form').find('button[type="submit"]').removeClass('is-loading');
        },
        highlight: function (element, errorClass) {
            const datalayer = element.dataset.datalayer;

            if (datalayer) {
                dataLayer.push(JSON.parse(datalayer));
            }

            $('.js-serverside').remove();
        },
        errorPlacement: function (error, element) {
            return false;
        }
    });

    $('.js-auth-form').on('submit', function() {
        if ($(this).valid()) {
            $(this).find('button[type="submit"]').addClass('is-loading');
        }
    });

    // Auth forms: add class to non-empty inputs
    $('.js-auth-form input').each(function() {
        if ($(this).val() !== '') {
            $(this).addClass('-filled');
        } else {
            $(this).removeClass('-filled');
        }
    });

    // Auth forms: add class to non-empty inputs on change
    $('.js-auth-form input').on('change', function() {
        if ($(this).val() !== '') {
            $(this).addClass('-filled');
        } else {
            $(this).removeClass('-filled');
        }
    });

    // Auth forms: toggle password visibility
    $('.js-auth-form input[type="password"] ~ .js-icon').on('click', function() {
        const modifier = '-password-visible';
        $(this).toggleClass(modifier);

        const input = $(this).prevAll('input');
        if ($(input).is('[type="password"]')) {
            $(input).attr('type', 'text');
        } else {
            $(input).attr('type', 'password');
        }
    });
}
